<template>
    <div class="position-relative">

        <Spinner
            v-show="isTableLoading"
            ref="spinner"
            class="spinner v-fade"
            size="large"
        />

        <div class="table-responsive min-height">
            <table
                ref="table"
                class="table table-sm table-hover mb-0"
                :class="{'table--loading': isTableLoading}"
            >
                <CostableTableHeading />
                <CostableTableGroups :groups="groups" />
                <CostableTableSubtotals v-if="hasContingency || hasEventManagementFee" />
                <CostableTableContingency v-if="canHaveContingency && hasContingency" />
                <CostableTableEventManagementFee v-if="hasEventManagementFee" />
                <CostableTableServiceCharge v-if="hasServiceCharge" />
                <CostableTableTotals />
            </table>
        </div>

        <CostableTableWithSelected />

    </div>
</template>

<script>
import CostableTableHeading from './CostableTableHeading';
import CostableTableGroups from './CostableTableGroups';
import CostableTableContingency from './CostableTableContingency';
import CostableTableEventManagementFee from './CostableTableEventManagementFee';
import CostableTableSubtotals from './CostableTableSubtotals';
import CostableTableTotals from './CostableTableTotals';
import CostableTableServiceCharge from './CostableTableServiceCharge';
import CostableTableWithSelected from './CostableTableWithSelected';

export default {

    components: {
        CostableTableHeading,
        CostableTableGroups,
        CostableTableContingency,
        CostableTableEventManagementFee,
        CostableTableSubtotals,
        CostableTableTotals,
        CostableTableWithSelected,
        CostableTableServiceCharge,
    },

    computed: {
        groups() {
            return this.$store.getters['costable/groups'];
        },
        isTableLoading() {
            return this.$store.getters['costable/isCostableTableLoading'];
        },
        canHaveContingency() {
            return this.$store.getters['costable/canHaveContingency'];
        },
        hasContingency() {
            return this.$store.getters['costable/hasContingency'];
        },
        hasEventManagementFee() {
            return this.$store.getters['costable/hasEventManagementFee'];
        },
        hasServiceCharge() {
            return this.$store.getters['costable/hasServiceCharge'];
        },
    },

    watch: {
        isTableLoading(isTableLoading) {
            this.positionSpinner();
            if (isTableLoading) this.addSpinnerEventListener();
            else this.removeSpinnerEventListener();
        },
    },

    mounted() {
        this.positionSpinner();
        this.addSpinnerEventListener();
    },

    methods: {
        addSpinnerEventListener() {
            document.addEventListener('scroll', this.positionSpinner);
        },
        removeSpinnerEventListener() {
            document.removeEventListener('scroll', this.positionSpinner);
        },
        positionSpinner() {
            // Get the bounding rect of the table element relative to the document.
            const tableRect = this.$refs.table.getBoundingClientRect();
            // Get the spinner element.
            const spinner = this.$refs.spinner.$el;
            // Calculate the distance the top of the spinner will be from the top of the table when centered relative to the viewport.
            const centerSpinnerDistanceToTableTop = window.outerHeight / 2 - tableRect.top - spinner.clientHeight;
            if (centerSpinnerDistanceToTableTop < 0) {
                // If the spinner is going to overflow the top of the table, pin it to the top of the table.
                spinner.style.top = 0;
            } else if (centerSpinnerDistanceToTableTop + spinner.clientHeight / 2 > tableRect.height) {
                // If the spinner is going to overflow the bottom of the table, pin it to the bottom of the table.
                spinner.style.top = `${tableRect.height - spinner.clientHeight}px`;
            } else {
                // Center the spinner relative to the viewport.
                spinner.style.top = `${centerSpinnerDistanceToTableTop - spinner.clientHeight / 2}px`;
            }
        },
    },

};
</script>

<style lang="scss" scoped>
.spinner {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}
@media (min-width: 768px) {
    .table-responsive {
        overflow-x: auto !important;
    }
}
.table {
    transition: opacity 0.25s ease-in-out;
    &--loading {
        opacity: 0.5;
        pointer-events: none;
        user-select: none;
    }
}
.min-height {
    min-height: 400px;
}
</style>
